import routes from '@/config/routes';
import { v3Get, v3Post } from '../axios.instance.V3';
import { ApiResponse } from '../types';

const getUsersWithImpersonatePermission = (): ApiResponse =>
  v3Get(`${routes.backendUrl.adminImpersonation.getUsersWithImpersonationPermission}`);

const impersonateUser = (userId: number): ApiResponse =>
  v3Post(`${routes.backendUrl.adminImpersonation.impersonateUser}?userId=${userId}`);

export const adminImpersonateApi = {
  getUsersWithImpersonatePermission,
  impersonateUser,
};
